import { useParams } from '@tanstack/react-router';

export function useTenantID({
  dontThrow = false,
}: { dontThrow?: boolean } = {}): string {
  const { tenantId } = useParams({ strict: false });
  if (!tenantId) {
    if (dontThrow) {
      return '';
    }
    throw Error('tenant_id is missing in route');
  }
  return tenantId ?? '';
}
